export default __webpack_public_path__ + "static/media/p6.a5f30baf.jpg";